module.exports = __webpack_public_path__ + "static/media/bgImage.b7486819.png";